import {Route, Routes} from "@angular/router";
import * as _ from "underscore";


export interface INavigationEntry {
  name: string;
  type: E_NAV_NODE_TYPE;
  href?: string;
  links: INavigationEntry[];
}


export declare type INavigationEntries = INavigationEntry[];


export enum E_NAV_NODE_TYPE {
  LEAF,
  INTERNAL
}


export function nav_createNavigation(routes: Routes): INavigationEntries {
  return createNavigationImpl(routes[1]);
}



function createNavigationImpl(route: Route): INavigationEntries {
  const result: INavigationEntries = [];

  _.each(route.children, child => {
    const node: INavigationEntry = <INavigationEntry>{};

    node.type = _.isArray(child.children) ? E_NAV_NODE_TYPE.INTERNAL : E_NAV_NODE_TYPE.LEAF;
    node.name = getNodeName(child);

    if (node.type === E_NAV_NODE_TYPE.LEAF) {
      node.href = joinLink(child.path);
    } else {
      node.links = createChildrenLinks(child.path, child.children);
    }

    result.push(node);
  });


  return result;
}


function createChildrenLinks(parentPath: string, children: Routes): INavigationEntries  {
  const result: INavigationEntries = [];
  _.each(children, child => {
    const node: INavigationEntry = <INavigationEntry>{};

    node.type = E_NAV_NODE_TYPE.LEAF;
    node.name = getNodeName(child);
    node.href = joinLink(parentPath, child.path);

    result.push(node);
  });
  return result;
}


function getNodeName(route: Route): string {
  return route.data ? route.data.name : route.path;
}


function joinLink(...rest): string {
  return `/${_.compact(rest).join("/")}`;
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/navigation-utils.ts